/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetOrganicTrafficConfigOptions,
  GetOrganicTrafficConfigResponses,
} from '../types/GetOrganicTrafficConfig'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Returns 404 when the order book has no stored configuration, in which case it is scored with the bot service's own configuration.
 * @summary Get an order book's organic activity score configuration
 * {@link /v1/bots/organic-traffic/config/:order_book_id}
 */
export function getOrganicTrafficConfig<ThrowOnError extends boolean = true>(
  options: Options<GetOrganicTrafficConfigOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetOrganicTrafficConfigResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/bots/organic-traffic/config/{order_book_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetOrganicTrafficConfigResponses, ThrowOnError>>,
  )
}
